module.exports = __webpack_public_path__ + "img/p41.5e54ab67.png";